import { ActionTree } from 'vuex';
import { AppState } from '@/store/app';
import { ReportState } from '@/store/reports/index';
import { LOAD_FLOW_LIST_OPTIONS, ON_REPORT_VIEW_EXIT } from '@/store/reports/actionTypes';
import { LOAD_FLOWS } from '@/store/bot-designer/actionTypes';
import { FlowStatus } from '@/features/bots/models/flowStatus';
import { FlowListItemViewModel } from '@/features/bots/models/flowListItemViewModel';
import {
  CLEAR_REPORTING_LIST_OPTIONS,
  REMOVE_ALL_REPORT_LABEL_VALUES,
  SET_FLOW_LIST_OPTIONS,
  SET_REPORTING_FLOW,
} from '@/store/reports/mutationTypes';

export const actions: ActionTree<ReportState, AppState> = {
  async [LOAD_FLOW_LIST_OPTIONS]({ commit, state, dispatch }) {
    let botFlows: FlowListItemViewModel[] = await dispatch(LOAD_FLOWS, true);
    botFlows = botFlows.filter((flow) => flow.status !== FlowStatus.Draft);

    commit(
      SET_FLOW_LIST_OPTIONS,
      botFlows.sort((flow1, flow2) => {
        return flow1.name.toLowerCase().localeCompare(flow2.name.toLowerCase());
      }),
    );

    const isSelectedFlowStillInList = botFlows.filter((flow) => flow.id === state.selectedFlowId).length > 0;
    if (!isSelectedFlowStillInList) {
      commit(SET_REPORTING_FLOW, 'all');
    }
  },

  async [ON_REPORT_VIEW_EXIT]({ commit }, { from, to }) {
    if (!to.includes('report-')) {
      commit(CLEAR_REPORTING_LIST_OPTIONS);
    }
    commit(REMOVE_ALL_REPORT_LABEL_VALUES);
  },
};
